import styled from 'astroturf/react'
import _Avatar from "Avatar.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/footer/avatar.js?styleId=Avatar";

const greyLevel5 = 'var(--color-grey-3, #CCCCCC)'
const colorBgWhiteL1 = 'var(--color-bg-white-l-1, rgba(255, 255, 255, 1))'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'

export const Avatar = /*#__PURE__*/styled('div', null, {
  displayName: "Avatar",
  styles: _Avatar
})
